import React, { Fragment, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// auth actions constants
import * as authActionTypes from "../../constants/actionTypes/auth";

// context
import { AuthContext } from "../../context/AuthContext";

//helper
import { parseJwt } from "../../helpers/auth/parseJwt";
import { requiredValue, validateInput2faCode } from "../../helpers/form/form";
import {
  getToken,
  persistAuth,
  getQrCode,
  clearQrCode,
} from "../../helpers/auth/auth";

// services
import { validate2fa } from "../../services/user";

//component
import { Button, Form, Alert, Row, Col, Input } from "antd";

const Validate2fa = () => {
  const {
    state: { user, homePath },
    dispatch,
  } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (user.isValidToken) {
      navigate(homePath || "/not-found");
    }
  }, [navigate, user, homePath]);

  // get from localStorage
  const qrCode = getQrCode();

  const jwtToken = getToken();

  // on submit validate code two factor auth
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [formError, setFormError] = useState();

  const onSubmitTwoStepsAuthCode = async (formValues) => {
    setButtonDisabled(true);

    const { verificationCode } = formValues;

    const data = {
      token: jwtToken,
      code: `${verificationCode}`,
    };

    try {
      const response = await validate2fa(data);
      const {
        data: { jwtToken, isValidToken },
      } = response;

      const user = { ...parseJwt(jwtToken), isValidToken };

      persistAuth(user, jwtToken);

      dispatch({
        type: authActionTypes.LOGIN,
        payload: user,
      });

      clearQrCode();
    } catch (error) {
      if (error.response.status === 401) {
        setFormError("invalid code");
      } else {
        setFormError("something went wrong !");
      }
    }

    setButtonDisabled(false);
  };

  return (
    <Fragment>
      <header
        className="d-flex align-items-center"
        style={{ backgroundColor: "#122955" }}
      >
        <img
          src="https://i.imgur.com/Cx6rjiB.png"
          alt="mtor logo"
          width="100px"
          className="ms-4"
        />
        <span className="display-5 text-light">
          mtor | Two Step Verification
        </span>
      </header>

      <div className="container py-5">
        <div className="d-flex flex-column fs-6">
          <p className="text-wrap">
            Instead of waiting for text messages, get verification codes from an
            authenticator app. It works even if your phone is offline.
          </p>

          <p className="pt-2">
            First, download Google Authenticator from the{" "}
            <a
              href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pli=1"
              target="_blank"
              rel="noreferrer"
            >
              Google Play Store
            </a>{" "}
            or the{" "}
            <a
              href="https://apps.apple.com/us/app/google-authenticator/id388497605"
              target="_blank"
              rel="noreferrer"
            >
              iOS App Store
            </a>
            .
          </p>
        </div>

        <Form
          name="twoStepsAuthCodeForm"
          layout="vertical"
          onFinish={onSubmitTwoStepsAuthCode}
          className="pt-4"
          autoComplete="off"
        >
          {qrCode && (
            <div className="d-flex flex-column align-items-center fs-6">
              <p>
                In the Google Authenticator app, tap the{" "}
                <span className="fw-bolder">+</span>
              </p>
              <p>
                Choose <span className="fw-bolder">Scan a QR code</span>
              </p>

              <div className="my-4 border border-3">
                <img src={qrCode} alt="qrCode" width="200px" />
              </div>
            </div>
          )}

          {formError && (
            <Row className="justify-content-center my-3">
              <Col lg={11} xs={23}>
                <Alert
                  message="Error"
                  description={formError}
                  type="error"
                  showIcon
                />
              </Col>
            </Row>
          )}

          <Row className="justify-content-center">
            <Col lg={11} xs={23}>
              <Form.Item
                label="Verification Code"
                name="verificationCode"
                rules={[requiredValue(), validateInput2faCode()]}
              >
                <Input maxLength={6} placeholder="Enter Verification Code" />
              </Form.Item>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={11} xs={23}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={buttonDisabled}
                  loading={buttonDisabled}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Fragment>
  );
};

export default Validate2fa;
